export function buttondownSubscribeUrl(): string | undefined {
  const username = import.meta.env.VITE_BUTTONDOWN_USERNAME?.trim();
  if (!username || !/^[A-Za-z0-9_-]+$/.test(username)) return undefined;
  return `https://buttondown.com/api/emails/embed-subscribe/${username}`;
}
